import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import MKBox from "components/MKBox";
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";
import { useLanguage } from "context/LanguageContext";

function Counters() {
  const { messages } = useLanguage();

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={messages.counters[0].count}
              suffix={messages.counters[0].suffix}
              title={messages.counters[0].title}
              description={messages.counters[0].description}
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard
              count={messages.counters[1].count}
              suffix={messages.counters[1].suffix}
              title={messages.counters[1].title}
              description={messages.counters[1].description}
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={messages.counters[2].count}
              title={messages.counters[2].title}
              description={messages.counters[2].description}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
